<template lang="pug">
div(v-if='$store.state.student.name')
  router-view
  //- preload
  //- 日期选择弹窗
  KmModal(v-model='showDateModal', :closable='true', class='date-select-modal' :hideFooter='true')
    .date-modal-content
      .date-modal-icon
        svg(width='60', height='60', viewBox='0 0 60 60', fill='none', xmlns='http://www.w3.org/2000/svg')
          circle(cx='30', cy='30', r='28', fill='#FFF4E5')
          path(d='M30 18V30L38 34', stroke='#FF9500', stroke-width='3', stroke-linecap='round')
      .date-modal-title 账号安全提醒
      .date-modal-desc 为了您的账号安全，建议您定期修改登录密码和认证手机号
      .date-modal-options
        .date-option(v-for='days in [3, 7, 15, 30]', :key='days', @click='selectDays(days)', :class='{ active: selectedDays === days }')
          | {{ days }}天后提醒
      .date-modal-tip 选择时间后，在此期间内不会再次提醒
  UpgradeModal(:visible.sync='showUpgradeModal', :phase.sync='upgradePhase', :periodName='upgradePeriodName', @complete='handleComplete')
</template>

<script>
import preload from './components/Stu/StuPractice/StuExam/preLoad'
import UpgradeModal from './components/dialog/UpgradeModal/app.vue'
import { getStudentInfo, sso, adjustScore, checkLogin, reLogin } from '@/api/index'
import Util from '@/util/Util'

const token_ = Util.getCookieValue('token')

export default {
  name: 'App',
  components: { preload, UpgradeModal },
  data() {
    return {
      // 日期选择弹窗相关
      showDateModal: false,
      selectedDays: null,
      isNotifyClickClosed: false,
      showUpgradeModal: false,
      upgradePhase: 'success',
      upgradePeriodName: '高中学段'
    }
  },
  methods: {
    initSocket(data) {
      let that = this
      this.$socket.on('connect', () => {
        that.$socket.emit('login', {
          uid: 's_' + data.id,
          scid: 'sc_' + data.school_class_id || '',
          cname: data.category_name || '',
          cid: data.country_id || '',
          lid: data.layer_id ? 'l_' + data.layer_id : '',
        })
      })

      this.sockets.subscribe('new_msg', (data) => {
        console.info('new_msg', data)
      })
      this.sockets.subscribe('update_online_count', (data) => {
        console.info('update_online_count', data)
      })
      if (!token_) {
        this.sockets.subscribe('oss', (data) => {
          // 单点登录
          this.$store.dispatch('oss', data)
        })
      }
      this.sockets.subscribe('newTask', (data) => {
        // 新练习推送
        this.$store.dispatch('newTask', data)
      })
    },
    fn(string) {
      const $key = this.$Utf8.parse('zMWFUBwzvUWJVxHWplatform')
      const $iv = this.$Utf8.parse('4563262494851526')
      // 默认cbc Pkcs7
      return this.$AES
        .decrypt(string, $key, {
          iv: $iv,
        })
        .toString(this.$Utf8)
    },
    getStudentInfo() {
      getStudentInfo((res) => {
        if (res.status === 1) {
          let data = JSON.parse(this.fn(res.data))
          this.$store.commit('student/init', data)
          this.$store.commit('setPopup', data.popup)
          this.$store.commit('setVipInfo', data.vip)
          this.checkGraduateModal(data)
          localStorage.setItem('defaultGrade', JSON.stringify(data.defaultGrade))
          localStorage.setItem('studentId', data.id)
          localStorage.setItem('isLsStu', data.ls_uid ? '1' : '0')
          if (!token_) {
            if (!localStorage.getItem('socketToken')) {
              localStorage.setItem(
                'socketToken',
                new Date().getTime() + Math.random().toFixed(10)
              )
            }
            sso({ token: localStorage.getItem('socketToken') })
          }
          this.checkSecurityReminder(data)
          // 2020.08.06 线上没开 所以注释websocket
          // this.initSocket(data)
        } else this.requestFail(res)
      })
    },
    adjustScore() {
      adjustScore().then((res) => {
        if (res.status === 1) {
          this.$store.commit('setCoefficient', res.data)
        }
      })
    },
    checkSecurityReminder(info) {
      const reminderData = localStorage.getItem('securityReminder')
      if (reminderData) {
        const data = JSON.parse(reminderData)
        const now = Date.now()
        const remindTime = data.remindTime || 0
        const daysDiff = (now - remindTime) / (1000 * 60 * 60 * 24)

        if (daysDiff >= data.selectedDays) {
          this.showSecurityNotification(info)
        }
      } else {
        this.showSecurityNotification(info)
      }
    },
    showSecurityNotification(info) {
      if (this.$route.path === '/stu/ownInfo') {
        return
      }
      if (info.settings && info.settings.changePass && info.settings.changePass.needChangePass) {
        this.isNotifyClickClosed = false
        this.notifyInstance = this.$notify({
          title: '账号安全',
          message: '为了您的账号安全，建议您定期修改登录密码！',
          offset: 100,
          duration: 0,
          onClick: () => {
            this.isNotifyClickClosed = true
            this.notifyInstance.close()
            if (info.settings.changePass.phoneCertified) {
              sessionStorage.setItem('targetTab', 'changePass')
            } else {
              sessionStorage.setItem('targetTab', 'verifyCertified')
            }
            this.$router.push({ path: '/stu/ownInfo' })
          },
          onClose: () => {
            if (!this.isNotifyClickClosed) {
              this.showDateModal = true
            }
          }
        })
      }
    },
    selectDays(days) {
      this.selectedDays = days
      const reminderData = {
        selectedDays: this.selectedDays,
        remindTime: Date.now(),
      }
      localStorage.setItem('securityReminder', JSON.stringify(reminderData))
      this.showDateModal = false
    },
    handleComplete() {
      this.showUpgradeModal = false
      if (this.$route.path.match('/stu/home/index')) {
        this.$router.go(0)
      } else {
        this.$router.push({ path: '/stu/home/index' })
      }
    },
    checkGraduateModal(data) {
      if (+data.isSeniorGraduate === 1) {
        this.upgradePhase = 'thanks'
        this.showUpgradeModal = true
      } else if (+data.isPrimaryGraduate === 1) {
        this.upgradePeriodName = '初中学段'
        this.upgradePhase = 'success'
        this.showUpgradeModal = true
      } else if (+data.isJuniorGraduate === 1) {
        this.upgradePeriodName = '高中学段'
        this.upgradePhase = 'success'
        this.showUpgradeModal = true
      }
    }
  },
  beforeCreate() { },
  async created() {
    window.$alert = this.$alert
    window.$alertOnly = this.$alertOnly
    document.addEventListener('copy', (e) => {
      let element = e.target
      let falg = false
      while (element && !falg) {
        falg = element.classList.contains('allow-replication')
        element = element.parentElement
      }
      if (!falg) {
        e.preventDefault()
        this.$alertOnly(
          '抱歉！暂不支持内容复制',
          '尊重知识从你我做起，如有疑问，请联系我们<br>400-018-9011',
          {
            useHtml: true,
            confirmTxt: '我知道了',
          }
        )
      }
    })
    document.title = window.ConfigNew.header.title
    const _isjf =
      window.navigator.userAgent.match(/Electron/) && !localStorage.getItem('exetype')
    this.$store.commit('setJF', _isjf)

    if (_isjf || localStorage.getItem('t2s')) {
      this.getStudentInfo()
      this.adjustScore()
    } else {
      this.$queueUp().then(() => {
        // 获取学生信息，存入store中
        this.getStudentInfo()
        this.adjustScore()
      })
    }
    let time = 0
    document.addEventListener('click', () => {
      const current = +new Date()
      const c = current - time
      const recorder = this.$store.state.$recorder
      // 不能打断录音
      var recording = recorder && (recorder._status === recorder.Utils.Status.recording ||
        recorder._status === recorder.Utils.Status.connecting)
      if ((c < 0 || c > 1.5 * 60 * 1000) && !recording) {
        checkLogin().then(res => {
          if (res.status === 4302) {
            this.$confirm(
              '下线通知',
              `<div style="text-align:left; width: 320px">您的账号于 ${res.data.login.loginDateTime} 在其他设备登录。该登录设备是${res.data.login.mobileModel}。如非本人操作，可能密码已经泄露。建议修改密码，保证账号安全。<div>`,
              {
                useHtml: true,
                confirmTxt: '重新登录',
                cancelTxt: '取消',
                closeOnClickModal: false,
                showClose: false,
                distinguishCancelAndClose: true,
              }
            ).then(res => {
              reLogin()
            }).catch(() => {
              window.location.href = '/login'
            })
          }
        })
        time = current
      }
    })
  },
}
</script>

<style lang="less">
@import url('./ui/css/ui.css');

#app {
  min-width: 1180px;
  min-height: 100vh;
}

// 日期选择弹窗样式
.date-select-modal {
  .modal-body {
    padding: 0!important;
  }
  .date-modal-content {
    padding: 20px 40px 0px;
    text-align: center;
  }
  .date-modal-icon {
    width: 60px;
    height: 60px;
    margin: 0 auto 20px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .date-modal-title {
    font-size: 20px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
  }
  .date-modal-desc {
    font-size: 14px;
    color: #999;
    margin-bottom: 30px;
    line-height: 1.6;
  }
  .date-modal-options {
    .date-option {
      height: 44px;
      margin-bottom: 10px;
      border: 1px solid #e0e0e0;
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #666;
      cursor: pointer;
      transition: all 0.3s;
      &:hover {
        border-color: #24cc7c;
        color: #24cc7c;
      }
      &.active {
        background: #24cc7c;
        color: #fff;
        border-color: #24cc7c;
      }
    }
  }
  .date-modal-tip {
    font-size: 12px;
    color: #999;
    margin-bottom: 20px;
  }
}

.iconfont {
  font-family: 'iconfont' !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}

@font-face {
  font-family: 'iconfont';
  /* project id 986912 */
  src: url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.eot');
  src: url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.eot?#iefix') format('embedded-opentype'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.woff2') format('woff2'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.woff') format('woff'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.ttf') format('truetype'),
    url('//at.alicdn.com/t/font_986912_8c1wwvxsspd.svg#iconfont') format('svg');
}

.loadingWarp {
  width: 100%;
  height: 668px;
  background: white;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/App.vue